'use client';

import SharedIntro, { AnimatedTitle } from '@framework/ui/Pages/Landing/Sections/Intro';
import StartActions from '../StartActions';
import video from '@/allocate/ui/assets/video.mp4';
import poster from '@/allocate/ui/assets/poster.webp';

import styles from './intro.module.scss';

const Intro = () => {
  return (
    <SharedIntro
      className={ styles.intro }
      title={ (
        <>
          <AnimatedTitle
            sliderList={ ['Powerful', 'Predictive', 'Integrated', 'Actionable'] }
            className={ styles.introAnimatedTitle }
          />{ ' ' }
          business intelligence for orders & allocations.
        </>
      ) }
      description={ (
        <p className={ styles.description }>
          Allocate transforms your investor orders and allocations data at new issue into actionable
          and predictive insights. Hundreds of the world’s leading issuers and broker-dealers
          use it to better understand investor behavior and improve syndication.
        </p>
      ) }
      video={ video }
      poster={ poster.src }
      actionButtons={ <StartActions /> }
    />
  );
};

export default Intro;
